var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWiseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 14,
    viewBox: "0 0 55 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1282_300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2291 6.23584C54.2291 3.09634 52.058 0.888428 49.0151 0.888428C45.1408 0.888428 42.5442 3.72459 42.5442 7.77468C42.5442 10.9352 44.7361 13.1221 47.8311 13.1221C50.646 13.1221 52.7441 11.7513 53.6061 9.56376H50.4798C50.0641 10.2445 49.1812 10.6733 48.1009 10.6733C46.4393 10.6733 45.4007 9.56376 45.3069 7.99401H54.0525C54.1671 7.39784 54.2291 6.88509 54.2291 6.23584ZM45.546 5.86951C45.8262 4.42576 47.218 3.27426 48.901 3.27426C50.3548 3.27426 51.4559 4.34176 51.4559 5.87009L45.546 5.86951ZM34.1413 12.8392L34.7023 9.82568C36.416 10.171 36.676 9.19743 37.1223 6.85359L37.3406 5.69159C37.9635 2.41618 39.2204 0.783428 42.8145 1.22326L42.253 4.23734C40.5393 3.89201 40.2382 5.19984 39.8544 7.22984L39.6361 8.39184C39.0126 11.7093 37.714 13.279 34.1419 12.8398L34.1413 12.8392ZM29.9451 12.8503L32.0641 1.17076H34.8581L32.7495 12.8503H29.9451ZM13.939 1.17076H16.6502L17.5331 9.61626L21.0855 1.17076H23.7753L24.7213 9.70026L28.1486 1.17076H30.8494L25.9365 12.8503H22.8623L21.8636 4.81251L18.4686 12.8508H15.4975L13.9401 1.17134L13.939 1.17076Z",
    fill: "#2E4369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.81181 4.26825L0.592285 7.36575H6.06565L6.63707 6.01591H3.86392L5.59844 4.26825L4.59107 2.52058H9.29618L4.95407 12.8502H6.58497L11.4979 1.17075H2.00492L3.81181 4.26825Z",
    fill: "#00B9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1282_300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiseLogo);
export default __webpack_public_path__ + "static/media/wise-logo.f072b07185a6b27d1667043d0e51aa19.svg";
export { ForwardRef as ReactComponent };